import { useQuery } from '@tanstack/react-query';
import commonService from '../../../services/common-service';
import { TagSpecResponse } from '@/types/tag';

// Query keys for caching and management
export const commonKeys = {
  contentTypes: ['content-types'],
  tagSpecs: ['tag-specs'],
  enums: ['enums'],
  enumByName: (name: string) => [...commonKeys.enums, name],
} as const;

/**
 * Hook to fetch content types
 */
export const useContentTypes = () => {
  return useQuery({
    queryKey: commonKeys.contentTypes,
    queryFn: () => commonService.getContentTypes(),
  });
};

/**
 * Hook to fetch tag specifications
 */
export const useTagSpecs = () => {
  return useQuery<TagSpecResponse>({
    queryKey: commonKeys.tagSpecs,
    queryFn: () => commonService.getTagSpecs(),
  });
};

/**
 * Hook to fetch enums
 */
export const useEnums = () => {
  return useQuery({
    queryKey: commonKeys.enums,
    queryFn: () => commonService.getEnums(),
  });
};

/**
 * Hook to fetch specific enum by name
 * @param name The name of the enum to fetch
 */
export const useEnumByName = (name: string) => {
  return useQuery({
    queryKey: commonKeys.enumByName(name),
    queryFn: () => commonService.getEnumByName(name),
    enabled: !!name, // Only run query if name is provided
  });
};

export const useAccessKeys = () => {
  return useQuery({
    queryKey: ['accessKeys'],
    queryFn: () => commonService.getAccessKeys(),
  });
};
